<script>
import PastStudentStatementsApi from "../../Services/Api/MeetingApi/PastStudentStatementsApi";
import ThePastStatementExpansionPanelContent from "./ThePastStatementExpansionPanelContent.vue";
import {mapState} from "vuex";
import MeetingVoteCommentCard from "./MeetingVoteCommentCard.vue";
export default {
  name: "ThePastStatementSection",
  components: {MeetingVoteCommentCard, ThePastStatementExpansionPanelContent},

  data() {
    return {
      tab: 0,
      pastStatements: [],
      meta: {},
    };
  },

  watch: {
    statement: function () {
      if (_.isNil(this.statement) || _.isEmpty(this.statement)) {
        this.meta = {};
        this.pastStatements = [];
      } else {
        this.getPastStudentStatements();
      }
    },
  },

  mounted() {
    this.getPastStudentStatements();
  },

  computed: {
    ...mapState({
      meeting: state => state.scholarship_meeting.meeting,
      statement: state => state.scholarship_competition.statement,
    }),

    isPastStatementPresent() {
      if (_.isNil(this.meta) && _.isEmpty(this.meta)) return false
      return this.meta.pastCompetitionsSize > 0;
    }
  },

  methods: {
    async getPastStudentStatements() {
      try {
        const response = await PastStudentStatementsApi.index(
          {meeting: this.meeting.id, statement: this.statement.id}
        );

        this.pastStatements = response.data.pastCompetitions;
        this.meta = response.data.meta;
      } catch (err) {
        console.log(err);
      }
    },

    statementPeriod(statement) {
      return statement.competition.attributes.period;
    },

    statementId(statement) {
      return statement.competition.attributes.id;
    },

    statementAchievementsUrl(statement) {
      return statement.competition.links.selfLink;
    }

  },

}
</script>

<template>
  <v-card
    elevation="0"
    class="rounded-t-0 rounded-b-xl"
  >
    <v-card-text v-if="!isPastStatementPresent" style="min-height: 120px">
      Список пуст
    </v-card-text>
    <v-card-text
      v-else
      class="px-0"
      :style="{'max-height': '70vh', 'overflow': 'auto'}"
    >
      <v-expansion-panels accordion>
        <v-expansion-panel
          v-for="(statement, i) in pastStatements"
          :key="statementId(statement)"
        >
          <v-expansion-panel-header class="text-h6">{{statementPeriod(statement)}}</v-expansion-panel-header>
          <v-expansion-panel-content class="px-0">
            <the-past-statement-expansion-panel-content
              @openAchievement="$emit('openAchievement', $event)"
              :link="statementAchievementsUrl(statement)"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
  </v-card>

</template>

<style scoped>
.v-expansion-panel-content>>> .v-expansion-panel-content__wrap {
  padding: 0 !important;
}
</style>